import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { headersBase, headersType } from "../../../utils/constants/headersForApi";

export const adminDashboardApi = createApi({
  reducerPath: "dashboard",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getCardStats: builder.query({
      query: ({ adminId = "", studioId = "", userId = "" }) => ({
        url: `/admin/Stats/summary?adminId=${adminId}&studioId=${studioId}&userId=${userId}`,
        method: "GET",
        headers: headersBase()
      }),
    }),
    getMonthWeekStats: builder.query({
      query: ({ adminId = "", studioId = "", userId = "" }) => ({
        url: `/admin/Stats/docssummary?adminId=${adminId}&studioId=${studioId}&userId=${userId}`,
        method: "GET",
        headers: headersBase()
      }),
    }),
    getCategoryStats: builder.query({
      query: ({ adminId = "", studioId = "", userId = "" }) => ({
        url: `/admin/Stats/docsmacrosummary?adminId=${adminId}&studioId=${studioId}&userId=${userId}`,
        method: "GET",
        headers: headersBase()
      }),
    }),
    getDownloadStats: builder.query({
      query: (query = "") => ({
        url: `/admin/Stats/summary/export/excel?summaryType=${query}`,
        method: "GET",
        headers: headersType(),
        responseHandler: async (response) => await response.blob(),
        cache: "no-cache",
      }),
    }),
    getTaskCardStats: builder.query({
      query: ({ adminId = "", studioId = "", userId = "", practiceId = "", practiceStatus = "", startDate = "", endDate = "" }) => ({
        url: `/admin/DashboardTask/collective-summary?adminId=${adminId}&studioId=${studioId}&userId=${userId}&practiceId=${practiceId}&practiceStatus=${practiceStatus}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: headersBase()
      }),
    }),
    getTaskBarActivity: builder.query({
      query: ({ adminId = "", studioId = "", userId = "", practiceId = "", practiceStatus = "", startDate = "", endDate = "" }) => ({
        url: `admin/DashboardTask/activity-summary?adminId=${adminId}&studioId=${studioId}&userId=${userId}&practiceId=${practiceId}&practiceStatus=${practiceStatus}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: headersBase()
      }),
    }),
    getTaskBarOperativeCapacity: builder.query({
      query: ({ adminId = "", studioId = "", userId = "", practiceId = "", practiceStatus = "", startDate = "", endDate = "" }) => ({
        url: `/admin/DashboardTask/operative-capacity-summary?adminId=${adminId}&studioId=${studioId}&userId=${userId}&practiceId=${practiceId}&practiceStatus=${practiceStatus}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: headersBase()
      }),
    }),
    getTaskBarEffort: builder.query({
      query: ({ adminId = "", studioId = "", userId = "", practiceId = "", practiceStatus = "", startDate = "", endDate = "" }) => ({
        url: `/admin/DashboardTask/effort-summary?adminId=${adminId}&studioId=${studioId}&userId=${userId}&practiceId=${practiceId}&practiceStatus=${practiceStatus}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: headersBase()
      }),
    }),
    doDownloadTaskStats: builder.query({
      query: ({ adminId = "", studioId = "", userId = "", practiceId = "", practiceStatus = "", startDate = "", endDate = "" }) => ({
        url: `/admin/DashboardTask/export/excel?adminId=${adminId}&studioId=${studioId}&userId=${userId}&practiceId=${practiceId}&practiceStatus=${practiceStatus}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: headersBase(),
        responseHandler: (response) => response.blob(),
      }),
    }),
    getTaskPieService: builder.query({
      query: ({ adminId = "", studioId = "", userId = "", practiceId = "", practiceStatus = "", startDate = "", endDate = "" }) => ({
        url: `/admin/DashboardTask/distribution-by-service?adminId=${adminId}&studioId=${studioId}&userId=${userId}&practiceId=${practiceId}&practiceStatus=${practiceStatus}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: headersBase()
      }),
    }),
    getTaskPieOpenPending: builder.query({
      query: ({ adminId = "", studioId = "", userId = "", practiceId = "", practiceStatus = "", startDate = "", endDate = "" }) => ({
        url: `/admin/DashboardTask/distribution-open-pending?adminId=${adminId}&studioId=${studioId}&userId=${userId}&practiceId=${practiceId}&practiceStatus=${practiceStatus}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: headersBase()
      }),
    }),
    getTaskPieStatus: builder.query({
      query: ({ adminId = "", studioId = "", userId = "", practiceId = "", practiceStatus = "", startDate = "", endDate = "" }) => ({
        url: `/admin/DashboardTask/distribution-open-complete?adminId=${adminId}&studioId=${studioId}&userId=${userId}&practiceId=${practiceId}&practiceStatus=${practiceStatus}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: headersBase()
      }),
    }),
  }),
});

export const {
  useGetCardStatsQuery,
  useGetMonthWeekStatsQuery,
  useGetCategoryStatsQuery,
  useLazyGetDownloadStatsQuery,
  useGetTaskCardStatsQuery,
  useGetTaskBarActivityQuery,
  useGetTaskBarOperativeCapacityQuery,
  useGetTaskBarEffortQuery,
  useLazyDoDownloadTaskStatsQuery,
  useGetTaskPieServiceQuery,
  useGetTaskPieOpenPendingQuery,
  useGetTaskPieStatusQuery
} = adminDashboardApi;
